import { type Language } from '@aikoa/i18n'
import { useQuery } from '@tanstack/react-query'
import { trpc } from '~/lib/trpc'

export function useUserMessagePreviews(language: Language) {
  return useQuery(trpc.preview.getUserMessagePreviews.queryOptions({ language }))
}
